import { ChangeDetectorRef, Directive, ElementRef, Input } from '@angular/core';
import { DataClassification } from '@summit/core';
import { SummitDisposing } from '@summit/models';
import { BehaviorSubject, combineLatest, takeUntil } from 'rxjs';
import { LayoutService } from '../services/layout.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[s-blur]',
  standalone: true
})
export class BlurDirective extends SummitDisposing {
  private dataTypeBs = new BehaviorSubject<DataClassification>('None');
  dataType$ = this.dataTypeBs.asObservable();
  @Input() set 's-blur'(type: DataClassification | undefined) {
    //console.log('config testing input', type);
    this.dataTypeBs.next(type ?? 'None');
  }

  constructor(
    private element: ElementRef,
    private layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
    combineLatest([this.layoutService.config$, this.dataType$])
      .pipe(
        takeUntil(this.disposing$)
        //tap(([config, dataType]) => console.log('config testing', config, dataType))
      )
      .subscribe(([config, dataType]) => {
        if (!config) return;
        switch (dataType) {
          case 'Pii':
            if (config.blurPii === true) {
              //console.log('blurPii adding blur');
              this.element.nativeElement.classList.add('blur');
            } else {
              //console.log('blurPii removing blur');
              this.element.nativeElement.classList.remove('blur');
            }
            break;
          case 'Financial':
            if (config.blurFinancial === true) {
              //console.log('blur Fin adding blur');
              this.element.nativeElement.classList.add('blur');
            } else {
              //console.log('blur Fin adding blur');
              this.element.nativeElement.classList.remove('blur');
            }
            break;
          default:
            break;
        }
        setTimeout(() => {
          this.changeDetectorRef?.detectChanges();
        }, 0);
      });
  }
}
